(function () {
  /**
   * Polyfill isInteger
   */
  Number.isInteger =
    Number.isInteger ||
    function (value) {
      return (
        typeof value === "number" &&
        isFinite(value) &&
        Math.floor(value) === value
      );
    };

  /**
   * Polyfill CustomEvent
   */
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined,
    };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

  /**
   * :scope polyfill
   * Source: https://github.com/jonathantneal/element-qsa-scope/blob/master/index.js
   */
  // try {
  //   // test for scope support
  //   document.querySelector(":scope *");
  // } catch (error) {
  //   (function (ElementPrototype) {
  //     // scope regex
  //     var scope = /:scope(?![\w-])/gi;

  //     // polyfill Element#querySelector
  //     var querySelectorWithScope = polyfill(ElementPrototype.querySelector);

  //     ElementPrototype.querySelector = function querySelector(selectors) {
  //       return querySelectorWithScope.apply(this, arguments);
  //     };

  //     // polyfill Element#querySelectorAll
  //     var querySelectorAllWithScope = polyfill(
  //       ElementPrototype.querySelectorAll
  //     );

  //     ElementPrototype.querySelectorAll = function querySelectorAll(selectors) {
  //       return querySelectorAllWithScope.apply(this, arguments);
  //     };

  //     // polyfill Element#matches
  //     if (ElementPrototype.matches) {
  //       var matchesWithScope = polyfill(ElementPrototype.matches);

  //       ElementPrototype.matches = function matches(selectors) {
  //         return matchesWithScope.apply(this, arguments);
  //       };
  //     }

  //     // polyfill Element#closest
  //     if (ElementPrototype.closest) {
  //       var closestWithScope = polyfill(ElementPrototype.closest);

  //       ElementPrototype.closest = function closest(selectors) {
  //         return closestWithScope.apply(this, arguments);
  //       };
  //     }

  //     function polyfill(qsa) {
  //       return function (selectors) {
  //         // whether the selectors contain :scope
  //         var hasScope = selectors && scope.test(selectors);

  //         if (hasScope) {
  //           // fallback attribute
  //           var attr = "q" + Math.floor(Math.random() * 9000000) + 1000000;

  //           // replace :scope with the fallback attribute
  //           arguments[0] = selectors.replace(scope, "[" + attr + "]");

  //           // add the fallback attribute
  //           this.setAttribute(attr, "");

  //           // results of the qsa
  //           var elementOrNodeList = qsa.apply(this, arguments);

  //           // remove the fallback attribute
  //           this.removeAttribute(attr);

  //           // return the results of the qsa
  //           return elementOrNodeList;
  //         } else {
  //           // return the results of the qsa
  //           return qsa.apply(this, arguments);
  //         }
  //       };
  //     }
  //   })(Element.prototype);
  // }

  /**
   * repeat polyfill
   * Source: https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
   */
  if (!String.prototype.repeat) {
    String.prototype.repeat = function (count) {
      "use strict";
      if (this == null) {
        throw new TypeError("can't convert " + this + " to object");
      }
      var str = "" + this;
      count = +count;
      if (count != count) {
        count = 0;
      }
      if (count < 0) {
        throw new RangeError("repeat count must be non-negative");
      }
      if (count == Infinity) {
        throw new RangeError("repeat count must be less than infinity");
      }
      count = Math.floor(count);
      if (str.length == 0 || count == 0) {
        return "";
      }
      // Ensuring count is a 31-bit integer allows us to heavily optimize the
      // main part. But anyway, most current (August 2014) browsers can't handle
      // strings 1 << 28 chars or longer, so:
      if (str.length * count >= 1 << 28) {
        throw new RangeError(
          "repeat count must not overflow maximum string size"
        );
      }
      var rpt = "";
      for (var i = 0; i < count; i++) {
        rpt += str;
      }
      return rpt;
    };
  }

  /**
   * Number.isNaN() polyfill
   * Source: https://github.com/leonderijke/Number.isNaN/blob/master/isnan.js
   */
  if (!Number.isNaN) {
    (function (global) {
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result =
            $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {}
        return result;
      })();

      var globalIsNaN = global.isNaN;

      // Source: http://wiki.ecmascript.org/doku.php?id=harmony:number.isnan
      var isNaN = function (value) {
        return typeof value === "number" && globalIsNaN(value);
      };

      if (defineProperty) {
        defineProperty(Number, "isNaN", {
          value: isNaN,
          configurable: true,
          writable: true,
        });
      } else {
        Number.isNaN = isNaN;
      }
    })(this);
  }
})();
